import { Subject, from } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import * as SearchApi from '../../apis/Search';

class SearchService {
    constructor(mode, isAiPill) {
        this.subject = new Subject();
        this.mode = mode;
        this.isAiPill = isAiPill;

        this.fetch = this.fetch.bind(this);
    }

    search(value) {
        this.subject.next(value);
    }

    fetch(value) {
        const { mode, isAiPill } = this;

        this.fetchedQuery = value;

        return from(SearchApi.get(value, mode, isAiPill));
    }

    suggestions() {
        return this.subject.pipe(debounceTime(500), distinctUntilChanged(), switchMap(this.fetch));
    }
}

export default SearchService;
